<template>
    <div class='hourssplit-graph-filter'>
        <div class="row" v-if="loaded">
            <div class="col-12">
                <el-card class="box-card">
                    <div class="row mobile-center">
                        <div class="col-8 vertical-center">
                            <el-select
                                v-model="managers"
                                filterable
                                :clearable=true
                                multiple
                                collapse-tags
                                placeholder="Filter managers"
                                @visible-change="managerFilterChange($event)"
                                class="manager-selector fl">
                                <el-option
                                    v-for="item in $store.getters['general/getStoreInterests']"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id">
                                </el-option>
                            </el-select>

                            <el-select
                                v-model="$store.state.cost.stores"
                                filterable
                                :clearable=true
                                collapse-tags
                                multiple
                                class="store-selector fl ml-5-howrly"
                                placeholder="Filter stores"
                                @visible-change="filterChange($event)"
                                @change="checkSelect($event)">
                                <el-option
                                    label="All stores"
                                    value="all">
                                </el-option>
                                <el-option
                                    label="No stores"
                                    value="none">
                                </el-option>
                                <el-option
                                    v-for="item in $store.getters['general/getStores']"
                                    :key="item.store_id"
                                    :label="item.store_name"
                                    :value="item.store_id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-4">
                            <el-radio-group @change="emitFilterChange()" v-model="$store.state.cost.hoursSplitSwitchValue" size="medium" class="vertical-center switch-right ml-5-howrly fr">
                                <el-radio-button label="Month"></el-radio-button>
                                <el-radio-button label="Store"></el-radio-button>
                                <el-radio-button label="Employee"></el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row mobile-center">
                        <div class="col-12">
                            <el-date-picker
                                class="fl mt-10"
                                @change="emitFilterChange()"
                                v-model="dateRange"
                                type="monthrange"
                                value-format="yyyy-MM-dd"
                                align="right"
                                unlink-panels
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <el-card class="box-card" style="height: 80px;">
                    <div class="card-body no-padding"></div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>

var debounce = require('debounce')
export default {
    data () {
        return {
            loaded: false,
            managers: [],
            dateRange: ['2020-01-01', '2020-03-01'],
            pickerOptions: {
                shortcuts: [{
                    text: 'Last month',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setMonth(start.getMonth() - 1)
                        end.setMonth(end.getMonth())
                        start.setDate(1)
                        end.setDate(1)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: 'Last 3 months',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setMonth(start.getMonth() - 3)
                        start.setDate(1)
                        end.setDate(1)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: 'Last 6 months',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setMonth(start.getMonth() - 6)
                        start.setDate(1)
                        end.setDate(1)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: 'This year',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date(new Date().getFullYear(), 0)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: 'Last year',
                    onClick (picker) {
                        let e = new Date().getFullYear()
                        let b = new Date().getFullYear() - 1
                        const end = String(e) + '-01-01'
                        const start = String(b) + '-01-01'
                        picker.$emit('pick', [start, end])
                    }
                }]

            }
        }
    },
    components: {
    },
    computed: {
    },
    methods: {
        getData () {
            let dates = this.formatDates()
            this.$store.dispatch('cost/getHoursSplitTable', { 'stores': this.$store.state.cost.stores, 'begin_date': dates[0], 'end_date': dates[1], 'type': this.$store.state.cost.hoursSplitSwitchValue })
            this.$store.dispatch('cost/getHoursSplitTotalTable', { 'stores': this.$store.state.cost.stores, 'begin_date': dates[0], 'end_date': dates[1] })
        },
        debounceInput: debounce(
            function () {
                this.getData()
            }, 500),
        filterChange (event) {
            if (event !== true) { // In this case the change is not submitted by the user yet
                this.debounceInput()
            }
        },
        formatDates () {
            var d = new Date(this.dateRange[1].split('-')[0], this.dateRange[1].split('-')[1], this.dateRange[1].split('-')[2])
            // d.setMonth(d.getMonth() + 1)
            var dd = d.getDate()
            var mm = d.getMonth()
            if (mm === 0) {
                mm = 12
            }
            var yyyy = d.getFullYear()
            if (dd < 10) {
                dd = '0' + dd
            }

            if (mm < 10) {
                mm = '0' + mm
            }
            let end = yyyy + '-' + mm + '-' + dd
            return [this.dateRange[0], end]
        },
        managerFilterChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                this.$store.dispatch('cost/updateStores', { 'stores': data }).then(response => {
                    this.emitFilterChange()
                })
            }
        },
        checkSelect (stores) {
            if (stores.includes('all')) {
                this.$store.dispatch('cost/updateStores', { 'stores': this.$store.getters['general/getStores'].map(x => x.store_id) }).then(response => {})
            } else if (stores.includes('none')) {
                this.$store.commit('cost/UPDATE_STORES', { 'stores': [] })
            }
        },
        emitFilterChange () {
            this.debounceInput()
        }
    },
    created () {
        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.managers = [parseInt(localStorage.getItem('user_id'))]
            this.$store.dispatch('cost/updateStores', { 'stores': this.$store.state.general.storeInterests.find(x => x.user_id === parseInt(localStorage.getItem('user_id')))['stores'] }).then(response => {
                this.loaded = true
                this.$emit('filterLoaded')
                this.getData()
            })
        })
    }
}
</script>

<style lang="scss">
.hourssplit-graph-filter {
    .el-date-editor .el-range-separator {
        padding: 0 5px;
        line-height: 32px;
        width: 10%;
        color: #303133;
    }
    .store-selector {
        min-width: 220px !important;
    }
    .manager-selector {
        min-width: 220px !important;
    }

}
</style>
